// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__Nfgbo","mobile":"style_mobile__vLsMh","laptop":"style_laptop__BpjjG","v3":"style_v3__BY+st","info":"style_info__Pkb1l"};